module.exports = __webpack_public_path__ + "img/hr-rock-big-11.de1e4c87.png";